import { EventEmitter, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import { DwModalService } from 'ng-quicksilver';
import { FxLoingingService } from 'app/implementation/auth/fx-login.service';
import { FxUserInfoService } from 'app/implementation/auth/fx-auth/fx-user-info.service';
import { DwRoutingMessageService, DwNewRouteKeyService } from '@webdpt/framework';
import { FxDapHttpClient } from 'app/implementation/shared/fx-http-client';
import { TranslateService } from '@ngx-translate/core';
import { MallEnquiryComponent } from './mall-product-center/mall-enquiry/mall-enquiry.component';
import { DefaultUrlSerializer } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class MallService {
  //申明发射事件
  public eventEmit: any;
  // 记录当前响应式平台
  public fxMedia: string = window.innerWidth <= 590 ? 'mobile' : (window.innerWidth <= 1200 ? 'pad' : 'pc');

  constructor(
    public http: FxDapHttpClient,
    public router: DwNewRouteKeyService,
    private routerA: Router,
    protected route: ActivatedRoute,
    private translateService: TranslateService,
    public dwMessage: DwRoutingMessageService,
    public fxLoingingService: FxLoingingService,
    public dwModalService: DwModalService,
    public fxUserService: FxUserInfoService, // 当前登录用户信息服务
  ) {
    this.eventEmit = new EventEmitter();
  }

  getDns(val: any, id: any) {
    //判断入参是否为空值
    if (val === null) {
      return;
    }

    //带id域名
    let urlId = /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*([\?&]\w+=\w*)*$/,
      //完整域名
      urlDns = /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*$/,
      //IP地址
      urlIp = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/,
      //省www域名
      urlNameDns = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/,
      //以http或https开头
      urlHttp = /(http|https):\/\/([\w.]+\/?)\S*/;

    let hasHttp = new RegExp(urlHttp, 'i');
    if (urlHttp.test(val) === true) {

      let newLink = val.slice(7);
      window.open("http://" + newLink)
      return;
    }

    let checkedUrl = urlId || urlDns || urlIp || urlNameDns;
    let checkUrl = new RegExp(checkedUrl, 'i');
    let text = checkUrl.test(val);
    if (text === true) {
      window.open("http://" + val)
    } else {
      if (id == '') {
        this.router.navigate([val])
      } else {
        this.router.navigate([val], { queryParams: { id: id } })
      }
    }
  }

  // 高级促销记录历程，赠品不写历程只有主品写历程，促销后价格记录主品的供价，叠加促销的历程记录是先记录一般促销再高级促销
  setHistoryDataSenior(dcdList, dccInfo, tableNo): Array<any> {
    // 如果只有一般促销，或者只有高级促销则只有一层dcd，如果促销叠加了，那么dcd下面还会再有一个dcd
    if (dcdList && dcdList.length) {
      dcdList.forEach(s => {
        s[tableNo + '_f_list'] = []; // 每个促销主品记录一笔历程，如果叠加了促销则记录两笔
        let seq1 = 1;   // 一般促销只有有一笔默认写死1，叠加了高级促销最多一笔为2
        // 判断是否有一般促销
        if (s.dcd_f_list && s.dcd_f_list.length) {
          s.dcd_f_list.forEach(t => {
            s[tableNo + '_f_list'].push({
              [tableNo + 'seq1']: seq1,  // 项序
              [tableNo + 'sprice']: t.dansprice,  // 原单价
              [tableNo + 'pdisc']: t.dcc004 == '2' ? t.eab073 : '',  // 折扣率%,如果是促销方式是折扣才会记录
              [tableNo + 'price']: t.eabprice,  // 现单价
              [tableNo + '001']: t.dccdocno,  // 促销单号
              [tableNo + '002']: t.dcdseq,  // 促销来源项次
              [tableNo + '003']: t.dcc004,  // 促销类型
              [tableNo + '004']: '',  // 促销组别，一般促销没有组别
            })
          })
          seq1 += 1;
        }
        s[tableNo + '_f_list'].push({
          [tableNo + 'seq1']: seq1,  // 项序
          [tableNo + 'sprice']: s[tableNo + '_f_list'].length ? s[tableNo + '_f_list'][0][tableNo + 'price'] : s.dansprice,  // 原单价，如果叠加促销，那高级促销的原单价为一般促销的现单价，否则为商品供价
          [tableNo + 'pdisc']: dccInfo.dcc004 == '2' ? dccInfo.dcc007 : '',  // 折扣率%,如果是促销方式是折扣才会记录
          [tableNo + 'price']: s.eabprice,  // 现单价
          [tableNo + '001']: s.dccdocno,  // 促销单号
          [tableNo + '002']: s.dcdseq,  // 促销来源项次
          [tableNo + '003']: dccInfo.dcc004,  // 促销类型
          [tableNo + '004']: s.dcq001,  // 促销组别，一般促销没有组别
        })
      });
    }
    return dcdList;
  }

  // 一般促销记录历程
  setHistoryDataBase(dcdList, tableNo): Array<any> {
    // 一般促销加购或下单主品只有一笔
    if (dcdList && dcdList.length) {
      dcdList.forEach(s => {
        if ((s.edd004 || s.eab026) && (s.edd007 == '1' || s.eab024 == '1')) {// 从加购或下单的数据中获取到有促销且为主品的数据进行写历程
          s[tableNo + '_f_list'] = [{// 一般促销加购或下单只会一笔一笔操作
            [tableNo + 'seq1']: 1,  // 项序
            [tableNo + 'sprice']: s.dansprice,  // 原单价
            [tableNo + 'pdisc']: s.dcc004 == '2' ? s.eab073 : '',  // 折扣率%,如果是促销方式是折扣才会记录
            [tableNo + 'price']: s.eabprice,  // 现单价
            [tableNo + '001']: s.dccdocno,  // 促销单号
            [tableNo + '002']: s.dcdseq,  // 促销来源项次
            [tableNo + '003']: s.dcc004,  // 促销类型
            [tableNo + '004']: '',  // 促销组别，一般促销没有组别
          }];
        }
      });
    }
    return dcdList;
  }

  // 收藏/取消收藏
  updCollect(param): Observable<any> {
    return new Observable((observer) => {
      if (this.fxUserService.userInfo['c_tourist'] === 'Y') {
        if(this.fxMedia && this.fxMedia === 'mobile'){
          //移动端跳转新的页面
          this.router.navigate(['mall/mobileLogin/mobileLogin'], { queryParams: { isShowHeaderBtn: 'N' } });
        }else{
          this.fxLoingingService.openLoginModal(this.fxMedia);
        }
        observer.next(false);
        observer.complete();
        return;
      }
      this.http.post('E/IFxed020Service/updCollect', { 'param': param }).subscribe(response => {
        if (response.success) {
          const msg = param.type === 'del' ? 'fxed020-取消收藏成功' : 'fxed020-收藏成功';
          this.dwMessage.success(this.translateService.instant(msg));
          observer.next(true);
          observer.complete();
        } else {
          this.dwMessage.error(response.message);
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  // 加购物车
  addShoppingCart(param): Observable<any> {
    return new Observable((observer) => {
      if (this.fxUserService.userInfo['c_tourist'] === 'Y') {
        if(this.fxMedia && this.fxMedia === 'mobile'){
          //移动端跳转新的页面
          this.router.navigate(['mall/mobileLogin/mobileLogin'], { queryParams: { isShowHeaderBtn: 'N' } });
        }else{
          this.fxLoingingService.openLoginModal(this.fxMedia);
        }
        observer.next(false);
        observer.complete();
        return;
      }
      this.http.post('E/ISaleService/addShoppingCart', { 'param': param }).subscribe(response => {
        if (response.success) {
          this.dwMessage.success(this.translateService.instant('fxed020-成功加入购物车'));
          observer.next(true);
          observer.complete();
        } else {
          this.dwMessage.error(response.message);
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  // 跳转购物车
  openShoppingCart(id?: string) {
    if (this.fxUserService.userInfo['c_tourist'] == 'Y') {
      if(this.fxMedia && this.fxMedia === 'mobile'){
        //移动端跳转新的页面
        this.router.navigate(['mall/mobileLogin/mobileLogin'], { queryParams: { isShowHeaderBtn: 'N' } });
      }else{
        this.fxLoingingService.openLoginModal(this.fxMedia);
      }
    } else {
      if(this.fxMedia && this.fxMedia === 'mobile'){
        this.router.navigate(['mall/shopping-cart'], { queryParams: { type: id,isShowHeaderBtn: 'N' } });
      }else{
        this.router.navigate(['mall/shopping-cart'], { queryParams: { type: id } });
      }
    }
  }

  // 获取费用抵扣数据
  getExpenseInfo(param): Observable<any> {
    return Observable.create(observer => {
      this.http.post('G/IGCommonService/getExpenseInfo', { 'param': param }).subscribe(response => {
        if (response.success && response.data && response.data.length) {
          observer.next(response.data);
          observer.complete();
        } else {
          observer.next([]);
          observer.complete();
        }
      });
    })
  }

  checkQtyCorrect(item): boolean {
    let flag = true;
    // 商品不可小于最小订购量
    if (Number(item.qty) < Number(item.productPromotionMinimumQuantity || 0)) {
      this.dwMessage.warning(this.translateService.instant('fxed020-minqty-error2'))
      flag = false;
    }

    // 商品不可大于最大订购量
    if (Number(item.productPromotionMaximumQuantity || 0) > 0 && Number(item.qty) > Number(item.productPromotionMaximumQuantity || 0)) {
      this.dwMessage.warning(this.translateService.instant('fxed020-maxqty-error'))
      flag = false;
    }
    return flag;
  }

  // 解决url没有变化路由不刷新问题
  getQueryParams() {
    return window.location.href.indexOf('ent=') == -1 ? { queryParams: { ent: this.fxUserService.userInfo['c_ent']}} : {}
  }
  // 判断文件类型是图片还是视频
  getMediumType(str) {
    const res =  str ? str.toLowerCase() : '';
    if (res.indexOf('mp4') !== -1 || res.indexOf('webm') !== -1 || res.indexOf('ogg') !== -1) {
      return 'video';
    } else {
      return 'image';
    }
  }
  // 刷新当前路由
  reloadCurrentUrl() {
    let entParam = window.location.href.indexOf('ent=') == -1 ? {ent: this.fxUserService.userInfo['c_ent']} : {};
    const currentUrl = this.routerA.url.split('?')[0];
    this.getUrlParams().subscribe(res => {
      let queryParams = res
      queryParams = Object.assign(queryParams, entParam);
      queryParams.isCurrentPage = 'Y';
      this.router.navigate([currentUrl], {queryParams: queryParams});
    });
  }

  // 获取url参数
  getUrlParams(): Observable<any> {
    return new Observable((observer) => {
      this.route.queryParams.subscribe(params => {
        let queryParams = JSON.parse(JSON.stringify(params))
        observer.next(queryParams);
        observer.complete();
      })
    })
  }
  // 询价
  // enquiry(item) {
  //   const modal = this.dwModalService.create({
  //     dwStyle: { top: '50px' },
  //     dwWidth: window.screen.width * 0.4,
  //     dwMaskClosable: false, // 點擊遮罩是否允許關閉
  //     dwContent: MallEnquiryComponent,
  //     dwClassName: "fx_modal_enquiry",
  //     dwWrapClassName: 'fx_md_modal',
  //     dwComponentParams: {
  //       caggoods: item.caggoods,
  //       caggoods_n1: item.caggoods_n1
  //     },
  //     dwFooter: [
  //       {
  //         label: this.translateService.instant('fxed020-提交信息'),
  //         type: 'primary',
  //         onClick: (data: any): void => {
  //           if (!data.acs002) {
  //             this.dwMessage.warning(this.translateService.instant('fxed020-请填写姓名！'));
  //             return;
  //           }
  //           if (!data.acs003) {
  //             this.dwMessage.warning(this.translateService.instant('fxed020-请填写电话！'));
  //             return;
  //           }
  //           if (!data.acs004) {
  //             this.dwMessage.warning(this.translateService.instant('fxed020-请填写地区！'));
  //             return;
  //           }
  //           if (!data.acs026) {
  //             this.dwMessage.warning(this.translateService.instant('fxed020-请填写商品需求！'));
  //             return;
  //           }
  //           if (!this.fxUserService.userInfo['c_user']) {
  //             if (!data.daecust_n1) {
  //               this.dwMessage.warning(this.translateService.instant('fxed020-请填写公司名称！'));
  //               return;
  //             }
  //             if (!data.dae001_n1) {
  //               this.dwMessage.warning(this.translateService.instant('fxed020-请填写公司全称！'));
  //               return;
  //             }
  //             if (!data.daetel) {
  //               this.dwMessage.warning(this.translateService.instant('fxed020-请填写公司电话！'));
  //               return;
  //             }
  //             if (!data.daeattn) {
  //               this.dwMessage.warning(this.translateService.instant('fxed020-请填写联系人！'));
  //               return;
  //             }
  //             if (!data.daemtel) {
  //               this.dwMessage.warning(this.translateService.instant('fxed020-请填写联系人手机！'));
  //               return;
  //             }
  //             if (!data.daemail) {
  //               this.dwMessage.warning(this.translateService.instant('fxed020-请填写联系人Email！'));
  //               return;
  //             }
  //             if (!data.daeaddrall) {
  //               this.dwMessage.warning(this.translateService.instant('fxed020-请填写公司地址！'));
  //               return;
  //             }
  //             if (!data.daeaddr) {
  //               this.dwMessage.warning(this.translateService.instant('fxed020-请填写详细地址！'));
  //               return;
  //             }
  //             if (!data.default) {
  //               this.dwMessage.warning(this.translateService.instant('fxed020-请勾选注册须知！'));
  //               return;
  //             }
  //           }
  //           if (!this.fxUserService.userInfo['c_user']) {
  //             const param = {
  //               daecust_n1: data.daecust_n1,
  //               dae001_n1: data.dae001_n1,
  //               daebper: data.daebper,
  //               daetel: data.daetel,
  //               daefax: data.daefax,
  //               dae028: data.dae028,
  //               daeattn: data.daeattn,
  //               daemtel: data.daemtel,
  //               daemail: data.daemail,
  //               dae027: data.dae027,
  //               dae030: data.dae030,
  //               dae024: data.dae024,
  //               daeaddr: data.daeaddr,
  //               daeent: this.fxUserService.userInfo['c_ent'],
  //               language: this.fxUserService.userInfo['c_lang'],
  //               daectry: "",
  //               daeprv: "",
  //               daecity: "",
  //               dbj_list: []
  //             };
  //             param.daectry = data.daeaddrall.country;
  //             param.daeprv = data.daeaddrall.province;
  //             param.daecity = data.daeaddrall.city;
  //             this.http.post<any>('E/IFxed020Service/addData', { 'param': param }).subscribe(
  //               response => {
  //                 if (response.success) {
  //                   var acrListModel = [];
  //                   const param1 = {
  //                     acrent: this.fxUserService.userInfo['c_ent'],
  //                     acr001: 'fxed049',
  //                   };
  //                   this.http.post<any>('E/IFxed020Service/getAcrInfo', { 'param': param1 }).subscribe(response => {
  //                     if (response.success) {
  //                       acrListModel = response.data;
  //                       const param = {
  //                         acs001: item.caggoods,
  //                         acs002: data.acs002,
  //                         acs003: data.acs003,
  //                         acs004: data.acs004,
  //                         acs026: data.acs026,
  //                         acscust: this.fxUserService.userInfo['c_user'],
  //                         acrListModel: acrListModel,
  //                         programId: 'fxed049',
  //                         table_no: 'acs_f',
  //                         zdbmdocno: 'acsdocno',
  //                         acstype: '9',
  //                         acslock: '1',
  //                         acsstus: 'Y',
  //                         acs016: moment(new Date()).format('YYYY-MM-DD').toString(),
  //                         c_ent: this.fxUserService.userInfo['c_ent'],
  //                         c_org: this.fxUserService.getEntParamById('c_E058')
  //                       };
  //                       this.http.post<any>('A/IFxad037Service/addDataAnonymous', { param }).subscribe(response => {
  //                         if (response.success) {
  //                           modal.destroy({});
  //                         }
  //                       }, error => {
  //                         modal.destroy({});
  //                       });
  //                     }
  //                   }, error => {
  //                     modal.destroy({});
  //                   });
  //                 }
  //               }, error => {
  //                 console.log("错误");
  //               }
  //             );
  //           } else {
  //             var acrListModel = [];
  //             const param1 = {
  //               acrent: this.fxUserService.userInfo['c_ent'],
  //               acr001: 'fxed049',
  //             };
  //             this.http.post('E/IFxed020Service/getAcrInfo', { 'param': param1 }).subscribe(response => {
  //               if (response.success) {
  //                 acrListModel = response.data;
  //                 const param = {
  //                   acs001: item.caggoods,
  //                   acs002: data.acs002,
  //                   acs003: data.acs003,
  //                   acs004: data.acs004,
  //                   acs026: data.acs026,
  //                   acscust: this.fxUserService.userInfo['c_cust'],
  //                   acrListModel: acrListModel,
  //                   programId: 'fxed049',
  //                   table_no: 'acs_f',
  //                   zdbmdocno: 'acsdocno',
  //                   acstype: '9',
  //                   acslock: '1',
  //                   acsstus: 'Y',
  //                   acs016: moment(new Date()).format('YYYY-MM-DD').toString(),
  //                 };
  //                 this.http.post<any>('A/IFxad037Service/addData', { param }).subscribe(response => {
  //                   if (response.success) {
  //                     if (item.c_P166 == 'Y' && this.fxUserService.userInfo['c_user']) {
  //                       this.http.post<any>('E/IFxed020Service/overNotice', { 'param': response.data, 'efa001': "34" }).subscribe(response => {
  //                         modal.destroy({});
  //                       }, error => {
  //                         modal.destroy({});
  //                       });
  //                     }
  //                   } else {
  //                     this.dwMessage.warning(response.message);
  //                   }
  //                 }, error => {
  //                   modal.destroy({});
  //                 });
  //               } else {
  //                 this.dwMessage.warning(response.message);
  //               }
  //             }, error => {
  //               modal.destroy({});
  //             });
  //           }
  //         }
  //       }
  //     ],
  //   });
  // }
}
// url序列化
export class CustomUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): any {
    return super.parse(decodeURIComponent(url));
  }

  serialize(tree: any): string {
    return super.serialize(tree).replace(/%3/g, '?').replace(/%3D/g, '=');
  }
}

